import alertShow from '../alert/alertShow';

const productPageAddToCart = () => {
    const productForm = document.getElementById('form-product');
    const url = 'index.php?route=checkout/cart/add';

    if (productForm) {
        productForm.addEventListener('submit', (e) => {
            e.preventDefault();

            console.log('productForm event submit detected!');

            const formData = new FormData(e.target);

            const buttonCart = document.getElementById('button-cart');
            buttonCart.disabled = true;
            buttonCart.classList.add('--Is-loading');

            fetch(url, {
                method: 'POST',
                body: new URLSearchParams(formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then(response => response.json())
                .then(json => {
                    const formProduct = document.getElementById('form-product');
                    const invalidInputs = formProduct.querySelectorAll('.is-invalid');
                    invalidInputs.forEach(input => input.classList.remove('is-invalid'));

                    const invalidFeedbacks = formProduct.querySelectorAll('.invalid-feedback');
                    invalidFeedbacks.forEach(feedback => feedback.classList.remove('d-block'));

                    if (json['error']) {
                        for (const key in json['error']) {
                            const newKey = key.replaceAll('_', '-');
                            const inputElement = document.getElementById('input-' + newKey);
                            inputElement.classList.add('is-invalid');
                            inputElement.querySelectorAll('.form-control, .form-select, .form-check-input, .form-check-label').forEach(el => el.classList.add('is-invalid'));

                            const errorElement = document.getElementById('error-' + newKey);
                            errorElement.innerHTML = json['error'][key];
                            errorElement.classList.add('d-block');
                            alert(json['error'][key]);
                        }
                    }

                    if (json['success']) {
                        alertShow('success', json['success']);
                        if (json['products_in_cart']) {
                            const counter = document.getElementById('cartBtnCounter');
                            counter.innerText = json['products_in_cart'];

                            const notification = document.getElementById('thisProductInCart');
                            notification.classList.remove('--Is-hidden');

                            if (json['cart_id']) {
                                const hiddenInputsBox = document.getElementById('hiddenInputsBox');
                                const hiddenInputs = document.querySelectorAll('#hiddenInputsBox input');
                                const newHiddenInputHTML = hiddenInputsBox.innerHTML;
                                const newHiddenInput = `<input type="hidden" name="key_${hiddenInputs.length + 1}" value="${json['cart_id']}">`;
                                hiddenInputsBox.innerHTML = newHiddenInputHTML + newHiddenInput;
                                console.log(json['cart_id']);
                                console.log(hiddenInputsBox.innerHTML);
                            }
                        }

                        /*
                        const headerCart = document.getElementById('header-cart');
                        fetch('index.php?route=common/cart|info')
                            .then(response => response.text())
                            .then(html => {
                                headerCart.innerHTML = html;
                            });
                         */
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                })
                .finally(() => {
                    buttonCart.disabled = false;
                    buttonCart.classList.remove('--Is-loading');
                });
        });
    }
}

export default productPageAddToCart;
